import { render } from "./VerificationTable.vue?vue&type=template&id=8ad0889c"
import script from "./VerificationTable.vue?vue&type=script&lang=js"
export * from "./VerificationTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__